import { savedInspectionsStorageV2 } from '@/store/idbStorage/savedInspectionsStorageV2';
import { logError } from '@/utils/logger';
import { systemConfig } from '@/config/systemConfig';
import { store } from '@/store/store';
import { startUpload } from '@/serviceworker/mediator';

/**
 * After login, resume uploads for inspections left in savedInspections (e.g. after upload 401 logout).
 */
export async function resumePendingUploads(): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.onLine) {
    return;
  }
  try {
    const hasInspections = await savedInspectionsStorageV2.hasInspections();
    if (hasInspections) {
      startUpload([]);
    }
  } catch (error) {
    logError(
      systemConfig.apiUrl,
      store.getState().auth.token || '',
      store.getState().auth.user,
      '[resumePendingUploads] failed to resume uploads',
      { error }
    );
  }
}
